
export default {
  name: 'Overlay',
  watch: {
    $route: {
      handler() {
        this.$emit('close-overlay')
      },
    },
  },
}
